import { ExternalStyles, Tag } from 'bold-ui'
import { TipoReceitaEnum } from 'graphql/types.generated'
import { tipoReceitaRecord } from 'types/enums'

interface TipoReceitaTagProps {
  tipoReceita: TipoReceitaEnum
  style?: ExternalStyles
}

export function TipoReceitaTag(props: TipoReceitaTagProps) {
  const { tipoReceita, style } = props

  return (
    <Tag type='info' style={style}>
      {tipoReceitaRecord[tipoReceita]}
    </Tag>
  )
}
